import RestrictionHandler from './RestrictionHandler';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../core/style/gstheme';
import withGS from '../core/withGShoc';
import AnonymousClassHandler from './AnonymousClassHandler';
import AnonymousPropertyHandler from './AnonymousPropertyHandler';
import DatatypeHandler from './DatatypeHandler';
import DatatypeConstraintHandler from './DatatypeConstraintHandler';

class BlankNodeHandler extends React.Component {

  render() {

    const { data, isReadOnly, id, graph, components, viewLang, onDelete, sourceResource, useWorkflow,
      defaultLang, projectIRI, context, sourceComponent, currentRange, top } = this.props;

    const dataTypeList = Array.isArray(data.type) ? data.type : [data.type];

    if (dataTypeList.includes("Restriction"))
      return (
        <RestrictionHandler
          id={id}
          top={top}
          graph={graph}
          useWorkflow={useWorkflow}
          handleNotAvailable={true}
          context={context}
          contextProperty={"isDefinedBy"}
          sourceResource={sourceResource}
          sourceComponent={sourceComponent}
          projectIRI={projectIRI}
          components={components}
          isReadOnly={isReadOnly}
          viewLang={viewLang}
          defaultLang={defaultLang} />
      );

    if (dataTypeList.includes("OwlClass"))
      return (
        <AnonymousClassHandler
          id={id}
          top={top}
          graph={graph}
          useWorkflow={useWorkflow}
          handleNotAvailable={true}
          sourceResource={sourceResource}
          sourceComponent={sourceComponent}
          context={context}
          contextProperty="isDefinedBy"
          projectIRI={projectIRI}
          components={components}
          isReadOnly={isReadOnly}
          viewLang={viewLang}
          defaultLang={defaultLang} />
      );

    if (dataTypeList.includes("InverseObjectProperty"))
      return (
        <AnonymousPropertyHandler
          id={id}
          top={top}
          graph={graph}
          useWorkflow={useWorkflow}
          handleNotAvailable={true}
          sourceResource={sourceResource}
          sourceComponent={sourceComponent}
          context={context}
          contextProperty="isDefinedBy"
          projectIRI={projectIRI}
          components={components}
          isReadOnly={isReadOnly}
          viewLang={viewLang}
          defaultLang={defaultLang} />
      );

    if (dataTypeList.includes("RdfsDatatype"))
      return (
        <DatatypeHandler
          id={id}
          top={top}
          graph={graph}
          handleNotAvailable={true}
          useWorkflow={useWorkflow}
          currentRange={currentRange}
          sourceResource={sourceResource}
          sourceComponent={sourceComponent}
          context={context}
          projectIRI={projectIRI}
          components={components}
          isReadOnly={isReadOnly}
          viewLang={viewLang}
          defaultLang={defaultLang} />
      );

    if (dataTypeList.includes("DatatypeConstraint"))
      return (
        <DatatypeConstraintHandler
          id={id}
          top={top}
          graph={graph}
          handleNotAvailable={true}
          onDelete={onDelete}
          sourceResource={sourceResource}
          sourceComponent={sourceComponent}
          context={context}
          contextProperty="isDefinedBy"
          projectIRI={projectIRI}
          components={components}
          isReadOnly={isReadOnly}
          viewLang={viewLang}
          defaultLang={defaultLang} />
      );

    return null;
  }
}

BlankNodeHandler.propTypes = {
  top: false
};

BlankNodeHandler.propTypes = {
  id: PropTypes.string,
  data: PropTypes.object,
  defaultLang: PropTypes.string,
  viewLang: PropTypes.string,
  onDelete: PropTypes.func,
  top: PropTypes.bool,
  currentRange: PropTypes.string,
  sourceResource: PropTypes.string,
  sourceComponent: PropTypes.string.isRequired,
  components: PropTypes.array,
  context: PropTypes.string,
  graph: PropTypes.string,
  useWorkflow: PropTypes.bool,
  projectIRI: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool
};

export default withStyles(styles)(withGS(BlankNodeHandler));